import { IDefineCommand, ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ITimeSliceTile, ISection } from '../../../interfaces/scheduler_interfaces';
import { SelectedUnscheduledSectionModel } from '../models/selected_unscheduled_section_model';

angular
  .module('capability-ng-scheduler')
  .service(
    'removeSelectedUnscheduledSectionCommand',
    function removeSelectedUnscheduledSectionCommandDefinition(
      defineCommandORM: IDefineCommand,
      ngSelectedUnscheduledSectionModel: SelectedUnscheduledSectionModel,
      log: any
    ) {
      'use strict';

      return defineCommandORM(
        'removeSelectedUnscheduledSectionCommand',
        function removeSelectedUnscheduledSectionCommand(deferred, section: ISection) {
          ngSelectedUnscheduledSectionModel.clear();
          deferred.resolve();
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/unscheduled_sections/commands/remove_selected_unscheduled_section_command.ts